import clsx from "clsx";
import { type HTMLAttributes } from "react";

import styles from "@/components/ui/Statistic/Label.module.css";

export const Label = (props: HTMLAttributes<HTMLDivElement>) => {
    const { className, ...otherProps } = props;

    return <div {...otherProps} className={clsx(styles.label, className)} />;
};
